module.exports = __webpack_public_path__ + "img/Cheer Megaphone16.a8225d15.jpg";